import { z } from 'zod';
export const AttendeeSchema = z.object({
    displayName: z.string().min(1),
    firm: z.string().min(1),
    isOjb: z.boolean(),
    email: z.string().email().optional(),
});
export const AttendeeGroupSchema = z.object({
    firm: z.string().min(1),
    isOjb: z.boolean(),
    members: z.array(z.string().min(1)),
});
//# sourceMappingURL=attendee.js.map